import React, { useContext, useRef, useState } from 'react'
import './Navbar.css'
import logo_icon from '../Assets/logo.png'
import cart_img from '../Assets/cart_icon.png'
import header_logo from '../Assets/header_waves.png'
import { Link } from 'react-router-dom'
import { ShopContext } from '../../Context/ShopContext'
import drop_down_icon from '../Assets/dropdownpng.png'
import cross_icon from '../Assets/cart_cross_icon.png'

const Navbar = () => {
  const {getTotalItem} = useContext(ShopContext)
  const [menu,setMenu] = useState("home")
  const menuRef = useRef(null)
  const dropdown_toggle = (e)=>{
    menuRef.current.classList.toggle("menu-visible");
    e.currentTarget.classList.toggle("open");
  }

  return (
    <div className='navbar'>
      <div className="main-logo"><img src={logo_icon} alt="" /></div>
      <div className='header-waves' ><img src={header_logo} alt="" /></div>
      
        <ul ref={menuRef} className='nav-links'>
          <img className='cross-icon' src={cross_icon} alt="" onClick={() => menuRef.current.classList.remove("menu-visible")}/>
          <li onClick={() => setMenu("home")}className={menu === "home" ? "active" : ""}> <Link to="/" >Home</Link></li>
          <li onClick={() => setMenu("about")}className={menu === "about" ? "active" : ""}> <Link to="/about">About</Link> </li>
          <li onClick={() => setMenu("contact")}className={menu === "contact" ? "active" : ""}><Link to="/contact">Contact</Link></li>
        </ul>
        <div className="login-cart">
          {localStorage.getItem('auth-token')?<button className='header-login-btn' onClick={()=>{localStorage.removeItem('auth-token');window.location.replace('/')}} >
            Logout</button>:<Link to="/login" ><button className='header-login-btn' >Login</button></Link>}
 
          <Link to="/cart" ><img src={cart_img} className='cart-img' alt="" /></Link> 
          <div className='nav-cart-count'>{getTotalItem()}</div>
          <img onClick={dropdown_toggle} className='nav-dropdown' src={drop_down_icon} alt="" />
          
          </div>
      </div>
  )
}

export default Navbar